import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=262b26c4&scoped=true&"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=262b26c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b26c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262b26c4')) {
      api.createRecord('262b26c4', component.options)
    } else {
      api.reload('262b26c4', component.options)
    }
    module.hot.accept("./DeliveryInfo.vue?vue&type=template&id=262b26c4&scoped=true&", function () {
      api.rerender('262b26c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/components/DeliveryInfo.vue"
export default component.exports